import { createCanvas } from 'lib/utils/canvas';

/**
 * Resizes an image. Keeps aspect ratio, using length as the longer side.
 */
export function resizeDataUrl(dataUrl: string, length: number, quality = 0.92) {
  return new Promise<string>((resolve, reject) => {
    const img = document.createElement('img');
    img.src = dataUrl;

    img.onload = () => {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      img.onload = undefined;
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      img.onerror = undefined;

      const [canvas, cleanupCanvas] = createCanvas();

      // Keep aspect ratio
      if (img.width > img.height) {
        canvas.width = length;
        canvas.height = (canvas.width / img.width) * img.height;
      } else {
        canvas.height = length;
        canvas.width = (canvas.height / img.height) * img.width;
      }

      const context = canvas.getContext('2d');
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      context.drawImage(img, 0, 0, canvas.width, canvas.height);

      const resizedDataUrl = canvas.toDataURL('image/jpeg', quality);
      context?.clearRect(0, 0, canvas.width, canvas.height);
      cleanupCanvas();
      resolve(resizedDataUrl);
    };

    img.onerror = () => {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      img.onload = undefined;
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      img.onerror = undefined;

      reject();
    };
  });
}

export function resizeImageElement(
  imageSource: HTMLCanvasElement | HTMLVideoElement | HTMLImageElement,
  outputBuffer: HTMLCanvasElement,
  length: number,
) {
  // Keep aspect ratio
  if (imageSource.width > imageSource.height) {
    outputBuffer.width = length;
    outputBuffer.height = (outputBuffer.width / imageSource.width) * imageSource.height;
  } else {
    outputBuffer.height = length;
    outputBuffer.width = (outputBuffer.height / imageSource.height) * imageSource.width;
  }

  const context = outputBuffer.getContext('2d');
  context?.clearRect(0, 0, outputBuffer.width, outputBuffer.height);
  context?.drawImage(imageSource, 0, 0, outputBuffer.width, outputBuffer.height);
}

/**
 * A promise-based wrapper for `Image`. Takes a source string and returns a promise
 * that resolves to the loaded image aspect ratio.
 */
export function readImageAspectRatio(source: string): Promise<number> {
  return new Promise((res) => {
    const img = new Image();
    img.onload = () => {
      // The image is loaded; sizes are available
      res(img.width / img.height);
    };
    img.onerror = () => {
      // if the image failed to load return null
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      res(null);
    };
    img.src = source;
  });
}
